import { getServiceAsync } from 'data/function';
export class CreateApplicationProcessor {
    static async process({ message, trackingProperties, source }) {
        try {
            const createApplicationService = await getServiceAsync('CreateApplicationService');
            const messageResponse = {
                response: await createApplicationService.createApplication({
                    image: message.content.image,
                    name: message.content.name,
                    layout: message.content.layout,
                }, message.content.template),
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
}
